import { getDynamicBreadcrumbKey } from './getDynamicBreadcrumbKey';
/**
 * Reducer for adding dynamic breadcrumbs.
 *
 * @param state the current dynamic breadcrumbs state
 * @param action includes the breadcrumbs to be added
 * @returns the updated dynamic breadcrumbs state
 */
export const dynamicBreadcrumbsReducer = (state, action) => {
    const updated = new Map(state);
    action.breadcrumbs.forEach((b) => updated.set(getDynamicBreadcrumbKey(b), b.displayName));
    return updated;
};
